import {sendGet} from "./base";

export function getAssignedExternalApplications() {
    return sendGet('external-app/assigned');
}